var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalDelete',_vm._g(_vm._b({},'ModalDelete',{ mediaItemId: _vm.mediaItemId },false),{ deleted: _vm.removeCampaignMediaItemId }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }